"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _imageViewer = _interopRequireDefault(require("element-ui/packages/image/src/image-viewer"));
var _file = _interopRequireDefault(require("@/api/common/file"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'GlImageView',
  components: {
    ElImageViewer: _imageViewer.default
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    urlList: {
      type: Array,
      default: null
    },
    initialIndex: {
      // 初始展示
      type: Number,
      default: 0
    },
    onShowOrigin: {
      type: Function,
      default: function _default() {}
    },
    onApplyTransfer: {
      type: Function,
      default: function _default() {}
    },
    isShowAction: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      index: this.initialIndex
    };
  },
  computed: {
    showViewer: {
      get: function get() {
        return this.show;
      },
      set: function set(s) {
        this.$emit('update:show', s);
      }
    },
    showOrigin: function showOrigin() {
      return !this.urlList[this.index].isOrigin;
    },
    istransfer: function istransfer() {
      return this.urlList[this.index].istransfer;
    },
    imagesList: function imagesList() {
      var list = [];
      this.urlList.forEach(function (item) {
        list.push(item.url);
      });
      return list;
    }
  },
  methods: {
    handlePrint: function handlePrint() {
      var printImg = document.createElement('img');
      printImg.setAttribute('id', 'imgBox');
      printImg.setAttribute('src', this.imagesList[this.index]);
      printImg.setAttribute('alt', '打印图片');
      var iframe = document.createElement('IFRAME');
      iframe.setAttribute('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;');
      document.body.appendChild(iframe);
      var doc = iframe.contentWindow.document;
      doc.body.appendChild(printImg);
      var pageStyle = 'html,body{text-align: center;}img{max-width:100%;max-height:100%;margin:0 auto}';
      var style = document.createElement('style');
      style.innerText = pageStyle;
      doc.getElementsByTagName('head')[0].appendChild(style);
      doc.close();
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    },
    handleDownload: function handleDownload() {
      // 下载
      var url = _file.default.getFileById + this.urlList[this.index].id;
      var elink = document.createElement('a');
      elink.style.display = 'none';
      elink.href = url;
      elink.setAttribute('download', 'file');
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    closeViewer: function closeViewer() {
      this.showViewer = false;
      this.$emit('close'); // 关闭回调
    },
    onSwitch: function onSwitch(val) {
      this.index = val;
    },
    /* 查看原图 */handleShowOrigin: function handleShowOrigin() {
      var _this = this;
      var id = this.urlList[this.index].id;
      _file.default.viewOriginImage(id).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res]));
        _this.onShowOrigin(_this.index, url);
      }, function (err) {
        // console.log('错误信息', err)
      });
    },
    /* 申请重发原图 */handleSendOrigin: function handleSendOrigin() {
      var _this2 = this;
      this.$confirm(this.$t('imagesViewer.isApplyForOriginImage'), this.$t('confirmMsg.title'), {
        confirmButtonText: this.$t('confirmMsg.submit'),
        cancelButtonText: this.$t('confirmMsg.cancel'),
        type: 'warning'
      }).then(function () {
        var data = {
          id: _this2.urlList[_this2.index].id
        };
        _file.default.resendOriginImage(data).then(function (res) {
          if (res.success) {
            _this2.$message({
              type: 'success',
              message: _this2.$t('imagesViewer.isApplySuccess')
            });
            _this2.onApplyTransfer(_this2.index);
          } else {
            _this2.$message({
              type: 'error',
              message: res.errorMessages
            });
          }
        }, function (err) {
          // console.log('err', err)
        });
      });
    }
  }
};